import useTranslation from 'next-translate/useTranslation';
import React from 'react';
import { twMerge } from 'tailwind-merge';

const ProductCardLightingLine = props => {
  const { t } = useTranslation('common');
  const { data, showProgress = true, className = '' } = props;
  if (data?.status === 'begoing' || !showProgress) {
    return null;
  }
  return (
    <div className={twMerge('mt-1 px-2', className)} data-role="claimed">
      <div
        data-testid="wid-product-lighting-progress-bar"
        className="h-2 w-full rounded mb-[6px] bg-surface-200-bg"
        data-role="proBg">
        <div className="h-2 rounded bg-pricing-bg" style={{ width: `${data?.progress || 0}%` }} />
      </div>
      <div data-testid="wid-product-lighting-progress-label" className="text-pricing-txt enki-body-2xs-medium">
        {t('claimed', { progress: data?.progress || 0 })}
      </div>
    </div>
  );
};

export default React.memo(ProductCardLightingLine);
